import type { HourReportAuditableMembershipResponse } from "./schemas"

export type HourReportAuditableMembershipViewModel = HourReportAuditableMembershipResponse & {
  fullname: string
}

export const makeHourReportAuditableMembershipViewModel = (
  membership: HourReportAuditableMembershipResponse
): HourReportAuditableMembershipViewModel => ({
  ...membership,
  fullname: `${membership.firstname} ${membership.lastname}`.trim(),
})
